module.exports = __webpack_public_path__ + "static/media/Avatar_8.3c2d2ded.svg";